import { useCallback, useEffect, useState } from 'react';
import { getAssignmentClosedLost } from './dashboardApi';
import type { AssignmentClosedLostResponse, GetOrderMetricsParams } from './dashboardApi';
import { getTodayDateStringKST } from '@/shared/lib/dashboard/dateRange';

export type AssignmentPeriodType = 'day' | 'week' | 'month';

export function useAssignmentClosedLost(params: GetOrderMetricsParams | string | undefined) {
  const resolvedParams: GetOrderMetricsParams =
    typeof params === 'string' ? { date: params } : (params ?? { date: getTodayDateStringKST() });

  const cacheKey = resolvedParams.date
    ? resolvedParams.date
    : `${resolvedParams.startDate}~${resolvedParams.endDate}`;

  const [data, setData] = useState<AssignmentClosedLostResponse | null>(null);
  const [error, setError] = useState<Error | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const mutate = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const result = await getAssignmentClosedLost(resolvedParams);
      setData(result);
    } catch (e) {
      setError(e instanceof Error ? e : new Error(String(e)));
    } finally {
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cacheKey]);

  useEffect(() => {
    mutate();
  }, [mutate]);

  return { data, error, isLoading, mutate };
}
